export const AIChatSessionFragment = gql`
  fragment AIChatSessionFragment on AIChatSession {
    id
    chats {
      ...AIAssistantChatFragment
    }
    startedAt
    user {
      ...UserDataFragment
    }
  }
`
